import { WORKSPACE_AGENT_PANEL_DEFAULT_FLOAT_HEIGHT, WORKSPACE_AGENT_PANEL_MIN_HEIGHT } from '~/constants/panelWidths';

/**
 * `Math.min`/`Math.max` pass `NaN` through, which would persist as the floating height and collapse
 * the card on the next load.
 */
export const clampWorkspaceAgentPanelHeight = (height: number, maxHeight = Number.POSITIVE_INFINITY): number => {
  if (!Number.isFinite(height)) {
    return WORKSPACE_AGENT_PANEL_DEFAULT_FLOAT_HEIGHT;
  }

  const upperBound = Number.isFinite(maxHeight)
    ? Math.max(WORKSPACE_AGENT_PANEL_MIN_HEIGHT, maxHeight)
    : Number.POSITIVE_INFINITY;

  return Math.min(upperBound, Math.max(WORKSPACE_AGENT_PANEL_MIN_HEIGHT, height));
};
